import { useCallback } from "react";

import { useDispatch, useSelector } from "react-redux";

import { useObjectMemo } from "../../../hooks";
import { useLibrary } from "../../../providers";

import { selectNetworkItems } from "./selectors";
import { actions as requestActions } from "./request.slice";
import { actions as responseActions } from "./response.slice";

import type { NetworkRequest, NetworkResponse } from "./types";

export const useNetworkItems = () => {
  return useSelector(selectNetworkItems);
};

export type NetworkItems = ReturnType<typeof useNetworkItems>;
export type NetworkItem = NetworkItems[0];

export const useRecordNetwork = () => {
  const dispatch = useDispatch();

  const config = useLibrary("config");
  const { recordingEnabled } = config.network;

  const recordRequest = useCallback(
    (request: NetworkRequest) => {
      if (!recordingEnabled) {
        return;
      }
      dispatch(requestActions.addOne(request));
    },
    [dispatch, recordingEnabled],
  );

  const recordResponse = useCallback(
    (response: NetworkResponse) => {
      if (!recordingEnabled) {
        return;
      }
      dispatch(responseActions.addOne(response));
    },
    [dispatch, recordingEnabled],
  );

  const recordCacheHit = useCallback(
    (requestId: string) => {
      if (!recordingEnabled) {
        return;
      }
      dispatch(requestActions.cacheHit(requestId));
    },
    [dispatch, recordingEnabled],
  );

  return useObjectMemo({
    recordRequest,
    recordResponse,
    recordCacheHit,
  });
};
